import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import { LabTestComponentDto, UpsertLabTestComponentDto } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/lab-test-component`;

export const createStandardComponents = (
    source: CancelTokenSource)
    : Promise<string> => {

  return axios
      .post(`${apiUri}/create-standard-components`, undefined, {cancelToken: source.token})
      .then(response => response.data);
}

export const convertLegacyTestPanelTestsToOrderItemTest = (
    source: CancelTokenSource)
    : Promise<string> => {

  return axios
      .post(
          `${apiUri}/convert-legacy-test-panel-tests-to-order-item-test`,
          undefined,
          {cancelToken: source.token}
      )
      .then(response => response.data);
}

export const getAllLabTestComponents = (
    source: CancelTokenSource)
    : Promise<LabTestComponentDto[]> => {

  return axios
      .get(apiUri, {cancelToken: source.token})
      .then(response => response.data);
}

export const getLabTestComponent = (
    id: number,
    source: CancelTokenSource)
    : Promise<UpsertLabTestComponentDto> => {

  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
}

export const addLabTestComponent = (
    upsertLabTestComponentDto: UpsertLabTestComponentDto,
    source: CancelTokenSource)
    : Promise<LabTestComponentDto> => {

  return axios
      .post(apiUri, upsertLabTestComponentDto, {cancelToken: source.token})
      .then(response => response.data);
}

export const editLabTestComponent = (
    id: number,
    upsertLabTestComponentDto: UpsertLabTestComponentDto,
    source: CancelTokenSource)
    : Promise<LabTestComponentDto> => {

  return axios
      .put(`${apiUri}/${id}`, upsertLabTestComponentDto, {cancelToken: source.token})
      .then(response => response.data);
}

export const deleteLabTestComponent = (
    id: number, source: CancelTokenSource)
    : Promise<string> => {

  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
}
